import React, { useEffect, useContext, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IconArrowOutlineDown, IconArrowOutlineRight } from 'components/Zui/Icon'
import { format } from 'utils/datetime'
import { arrayDifference } from 'utils/helpers'
import { useToggle } from 'hooks'
import { FileContext } from 'features/patient-details/Details'
import {
    getFileThumbnails,
    getFileIndicators,
    thumbnailSelector,
} from 'features/patient-file-thumbnail/thumbnailSlice'
import Thumbnail from 'features/patient-file-thumbnail/Thumbnail'
import { Checkbox } from 'components/Zui'
import './index.css'

const Treatment = ({
    data,
    defaultOpen,
    filter,
    files,
    handleFavorite,
    handleClick,
    handleSelectFile,
}) => {
    const reduxDispatch = useDispatch()
    const { selectable } = useContext(FileContext)
    const { isOpen, onToggle } = useToggle(defaultOpen)
    const [filteredFiles, setFilteredFiles] = useState([])

    const thumbnailCache = useSelector(state => thumbnailSelector.selectIds(state))
    const { isLoading, isError, indicatorsCache } = useSelector(state => state.thumbnails)

    const arrayDiffWithFilteredFiles = array => {
        return arrayDifference(
            filteredFiles.map(f => f.fileId),
            array
        )
    }

    const isSelected = () => {
        const arrDiffLen = arrayDiffWithFilteredFiles(selectable.selectedFiles).length

        if (arrDiffLen && arrDiffLen !== filteredFiles.length) {
            return 'mixed'
        }
        if (!Boolean(arrDiffLen) && (files === undefined || Boolean(filteredFiles.length))) {
            return true
        }
        return false
    }

    useEffect(() => {
        if (filteredFiles && isOpen) {
            const thumbnailIds = filteredFiles.map(f => f.thumbnailId).filter(f => f)
            const thumbnailDiff = arrayDifference(thumbnailIds, thumbnailCache)
            const fileIds = filteredFiles.map(f => f.fileId)
            const fileDiff = arrayDifference(fileIds, indicatorsCache)

            if (thumbnailIds.length && thumbnailDiff.length) {
                reduxDispatch(getFileThumbnails(thumbnailDiff.join()))
            }
            if (fileIds.length && fileDiff.length) {
                reduxDispatch(getFileIndicators({ ids: fileDiff.join() }))
            }
        }
    }, [filteredFiles, isOpen])

    useEffect(() => {
        if (files) {
            let filtered = files
            if (filter !== 'all') {
                filtered = files.filter(f => f.fileType === filter)
            }

            setFilteredFiles(filtered)
        }
        return () => setFilteredFiles([])
    }, [files, filter])

    const handleSelect = val => {
        const fileIds = filteredFiles.map(f => f.fileId)
        handleSelectFile(val, fileIds)
    }

    return (
        <Header
            onToggle={onToggle}
            isOpen={isOpen}
            date={data.acquisitionDate}
            handleSelect={handleSelect}
            isSelected={isSelected()}
        >
            {isOpen && filteredFiles.length > 0 && (
                <div className="accordion-data-wrapper">
                    <div className="accordion-data-container">
                        {filteredFiles.map(file => {
                            return (
                                <Thumbnail
                                    data={file}
                                    key={file.fileId}
                                    handleSelectFile={handleSelectFile}
                                    isLoading={isLoading}
                                    handleFavorite={handleFavorite}
                                    handleClick={handleClick}
                                />
                            )
                        })}
                    </div>
                </div>
            )}
        </Header>
    )
}

const Header = ({ children, onToggle, isOpen, date, handleSelect, isSelected }) => {
    const arrowIcon = isOpen ? (
        <IconArrowOutlineDown className="arrow" size="s" />
    ) : (
        <IconArrowOutlineRight className="arrow" size="s" />
    )
    return (
        <div className="header-wrap">
            <div className="header-header">
                <div className="header-data">
                    <div className="header-open-arrow" onClick={onToggle}>
                        {arrowIcon}
                    </div>

                    <Checkbox
                        style={{ display: 'flex', fontSize: '14px' }}
                        name="terms"
                        theme="zbds-dark"
                        enableMixed
                        value={isSelected}
                        onChange={e => handleSelect(e.target.value)}
                    >
                        <span className="checkbox-label" style={{ color: '#D1D9E5' }}>
                            {format(date)}{' '}
                        </span>
                    </Checkbox>
                </div>
            </div>
            {children}
        </div>
    )
}

export default Treatment
